import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, Typography, Checkbox } from '@material-ui/core';

import Tooltip from 'src/components/tooltip';

import TooltipIcon from 'src/assets/icons/tooltip.svg';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    paddingLeft: 9,
    display: 'flex',
  },
}));

export default function CustomCheckbox({ id, label, tooltipText, checked, onChange }) {
  const classes = useStyles();
  const [isChecked, setIsChecked] = useState(false);

  const handleChange = () => {
    setIsChecked(!isChecked);
  };

  return (
    <div className={classes.root}>
      <Checkbox name={id} checked={checked || isChecked} onChange={onChange || handleChange} />
      <Typography>{label}</Typography>
      {tooltipText && (
        <Tooltip title={tooltipText} arrow>
          <div className={classes.icon}>
            <TooltipIcon />
          </div>
        </Tooltip>
      )}
    </div>
  );
}

CustomCheckbox.propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  tooltipText: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

// CustomCheckbox.defaultProps = {
//   checked: false,
//   onChange: () => {},
//   tooltipText: false,
//   id: 'checkbox',
// };
